module.exports = __webpack_public_path__ + "img/y8.0ddf5b30.jpg";